module.exports = __webpack_public_path__ + "static/media/vacctrak_app.af93a249.png";